<span>
  <span class="icon"><nv-icon *ngIf="icon" [name]="icon"></nv-icon></span>
  <span>{{ data }}</span>
</span>
